import React from 'react';
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { AlignmentOptions } from "components/pdfViewer/types";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";

export type AddToWalletButtonBlockType = Omit<FormBlockType, "data"> & {
    data: {
        width: number;
        align: AlignmentOptions
    },
}

export default function AddToWalletButtonsBlock(block: AddToWalletButtonBlockType) {
    const { data: { width } } = block;
    const { contact } = useFormFlow();
    const source = "https://storage.googleapis.com/static-nl-prod/business/add_to_wallet/h-lg-form.png";

    if (!contact) {
        return null;
    }

    return (
        <BlockWrapper name={block.name} hidden={false}>
            <a href={contact.add_to_wallet_url} target="_blank">
                <img
                    alt={"add-to-wallet"}
                    src={source}
                    style={{ width: width + "%" }}
                />
            </a>
        </BlockWrapper>
    );
}